import { render, staticRenderFns } from "./children-list.vue?vue&type=template&id=6037c993&scoped=true&"
import script from "./children-list.vue?vue&type=script&lang=js&"
export * from "./children-list.vue?vue&type=script&lang=js&"
import style0 from "./children-list.vue?vue&type=style&index=0&id=6037c993&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6037c993",
  null
  
)

export default component.exports